<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <StoriesTabLinks />
                    <StoriesCard :entity="entity" />
                    <CRow form class="form-group">
                        <StoriesGrid :pictures="entity.pictures" />
                    </CRow>
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="$router.push(`/stories`)"
                    >Назад</CButton>
                    <CButton
                        v-if="entity.id"
                        variant="outline"
                        color="danger"
                        class="ml-4"
                        @click="promptDelete"
                    >Удалить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import StoriesTabLinks from '@/components/stories/StoriesTabLinks';
    import StoriesCard from '@/components/stories/StoriesCard';
    import StoriesGrid from '@/components/stories/StoriesGrid';

    export default {
        name: 'Story',

        components: {
            StoriesTabLinks,
            StoriesCard,
            StoriesGrid,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/stories/${id}`)).data;
            },
            async promptDelete() {
                const { id } = this.$route.params;
                await this.axios.delete(`/stories/${id}`);
                this.goBack();
            },
            goBack() {
                this.$router.push({ path: `/stories` });
            },
        },
    };
</script>
